// src/context/brandVoice/ui/BilingualColumns.jsx — the bilingual ENVELOPE of a bucket-D field
// (the three "avoid" lists): the same single-language editor twice, Italian and English.
//
// ⭐ Sheet 08: bilingual is an envelope over the widget, not a sixth widget — so it is generic
// and DocFields wraps whichever editor the field has (str_list now, record_list later).
// ⭐ Decision 1 (2026-09-28): two INDEPENDENT columns — each language has its own rows, its
// own × and its own "+ Aggiungi", and the two lists may differ in length. ⛔ Not sheet 10's
// paired row: the API takes two independent lists, and emptying one does not empty the other.
// ⛔ The English is TYPED by the user: these guardrails are never machine-translated (rule 4).
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_SANS, RADII, SEMANTIC } from '../../../constants/theme.js';

const HEAD = {
  fontSize: 11, fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase',
  color: COLORS.textTertiary, marginBottom: 8,
};
const CHIP = {
  display: 'inline-block', marginBottom: 12, padding: '2px 8px', borderRadius: RADII.pill,
  border: `1px dashed ${COLORS.borderStrong}`, color: SEMANTIC.attenzione.fg, fontSize: 11, fontWeight: 600,
};

export default function BilingualColumns({ it, en }) {
  const { t } = useTranslation('context');
  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <span style={CHIP}>{t('brandVoice.bilingual.chip')}</span>
      <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap', alignItems: 'flex-start' }}>
        {/* The visible heading is aria-hidden so the group's name is not announced twice. */}
        <div role="group" aria-label={t('brandVoice.bilingual.it')} style={{ flex: '1 1 320px', minWidth: 0 }}>
          <div style={HEAD} aria-hidden="true">{t('brandVoice.bilingual.it')}</div>
          {it}
        </div>
        <div role="group" aria-label={t('brandVoice.bilingual.en')} style={{ flex: '1 1 320px', minWidth: 0 }}>
          <div style={HEAD} aria-hidden="true">{t('brandVoice.bilingual.en')}</div>
          {en}
        </div>
      </div>
    </div>
  );
}
